import React, { useContext, useMemo } from "react";
import { NavLink } from "react-router-dom";
import AuthContext from "../contexts/AuthContext";
import "./Sidebar.css";
import { FaSignOutAlt, FaBars, FaTimes } from "react-icons/fa";
import { useState, useEffect } from "react";

// Hook para detectar largura da tela em tempo real
function useIsMobile(breakpoint = 900) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= breakpoint);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);
  return isMobile;
}

const Sidebar = ({ menuItems }) => {
  const { user, logout } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile(900);

  useEffect(() => {
    if (!isMobile) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [isMobile]);

  useEffect(() => {
    if (isMobile) {
      document.body.classList.toggle("no-scroll", open);
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => document.body.classList.remove("no-scroll");
  }, [isMobile, open]);

  const computedMenuItems = useMemo(() => menuItems || [], [menuItems]);

  const sidebarClassName = isMobile
    ? `sidebar ${open ? "is-open" : ""}`
    : "sidebar";

  return (
    <>
      {isMobile && (
        <button
          className="sidebar-toggle-btn"
          onClick={() => setOpen((current) => !current)}
          aria-label={open ? "Fechar menu" : "Abrir menu"}
        >
          {open ? <FaTimes size={22} /> : <FaBars size={22} />}
        </button>
      )}
      {isMobile && open && (
        <div
          className="sidebar-backdrop"
          onClick={() => setOpen(false)}
          aria-hidden="true"
        />
      )}
      <aside className={sidebarClassName} aria-label="Menu de navegação">
      <div className="sidebar-header">
        <div className="sidebar-title">
          <img
            src={"/logo.png"}
            alt="Logotipo do Portal Seletivo"
            className="sidebar-logo"
          />
          <h3>Portal Seletivo</h3>
        </div>
      </div>
      <div className="sidebar-user">
        <p>Bem-vindo,</p>
        <strong>{user?.nome}</strong>
      </div>
      <nav className="sidebar-nav">
        <ul>
            {computedMenuItems.map((item, index) => (
              <li key={index}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) => (isActive ? "active" : "")}
                  onClick={() => (isMobile ? setOpen(false) : undefined)}
                >
                  {item.icon}
                  <span>{item.name}</span>
                </NavLink>
              </li>
            ))}
        </ul>
      </nav>
      <div className="sidebar-footer">
        <button onClick={logout} className="btn-modern btn-danger logout-btn">
          <FaSignOutAlt size={18} />
          Sair
        </button>
      </div>
      </aside>
    </>
  );
};

export default Sidebar;
